/* global OfficeRuntime */

// Stable per-install device id. The backend uses it for email/password login and email codes
// (e.g. deciding when an email re-verification is due), so it must survive restarts.
const DEVICE_ID_KEY = "device_id";

const newId = () =>
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

export async function getDeviceId(): Promise<string> {
  try {
    if (typeof OfficeRuntime !== "undefined" && OfficeRuntime.storage) {
      let id = await OfficeRuntime.storage.getItem(DEVICE_ID_KEY);
      if (!id) {
        id = `outlook-${newId()}`;
        await OfficeRuntime.storage.setItem(DEVICE_ID_KEY, id);
      }
      return id;
    }
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = `outlook-${newId()}`;
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return `outlook-${newId()}`;
  }
}
